/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { ServiceCreateDto } from '../../models/service-create-dto';
import { ServiceItem } from '../../models/service-item';

export interface ServiceControllerUpdate$Params {
  id: number;
      body: ServiceCreateDto
}

export function serviceControllerUpdate(http: HttpClient, rootUrl: string, params: ServiceControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: ServiceItem;
}>> {
  const rb = new RequestBuilder(rootUrl, serviceControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: ServiceItem;
      }>;
    })
  );
}

serviceControllerUpdate.PATH = '/service/{id}';
